import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getDriverLoaded, LoadDriver, getDriverLoading, ReportsState } from '../store';
import { tap, filter, take, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DriverGuard  {

    constructor(private store: Store<ReportsState>) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.checkstore(next.params.cacheKey);
    }

    checkstore(cacheKey: string): Observable<boolean> {
        return this.store.pipe(
            select(getDriverLoaded),
            tap(loaded => {
                console.log(cacheKey);
                
                if (!loaded)
                    this.store.dispatch(new LoadDriver(cacheKey));
            }),
            take(1),
            map(() => true)
        );
    }
}
